module.exports = __webpack_public_path__ + "static/media/lebron.dbde6959.jpg";